import { useSetAtom } from "jotai";

import { teachersAtom } from "@/atom/drawBoard";

import { updateCourseSettings } from "@/services/Course/courseApi";

import { updateLeftConsoleSettings } from "@/services/User/userApi";

const useUpdateCourseSettings = () => {
  const setTeachers = useSetAtom(teachersAtom);
  // const selectedBg = useAtomValue(selectedBgAtom);
  // const teacherSelected = useAtomValue(teacherSelectedAtom);
  // const isWorkLeftPanelOpen = useAtomValue(isWorkLeftPanelOpenAtom);
  // const barrage = useAtomValue(barrageAtom);

  const updateChangeInPanel = async (
    teacher: string,
    bg: string,
    br: string,
    config_type: string,
    cp: string,
    sr: number = 0
  ) => {
    let data: any = {
      configType: config_type,
      voice: teacher,
      background: bg,
      barrage: br,
      caption: cp,
      speedRatio: sr,
    };

    let res = await updateCourseSettings(data);
    if (res.code === 0 && res.msg === "success") {
      setTeachers(res.data.voice);
    }
  };

  const updateLeftPanelStatus = async (isPanelOpen: boolean) => {
    let data: any = {
      configType: "console_setting",
      workbench: isPanelOpen ? "展开" : "收起",
    };

    await updateLeftConsoleSettings(data);
  };

  return { updateChangeInPanel, updateLeftPanelStatus };
};

export default useUpdateCourseSettings;
